import React from 'react';
import { withTrans } from "@i18n/withTrans";

import { StylingElement } from './StylingElement';
import { MediaStyle } from './MediaStyle';
import { ImageLanguage } from './ImageLanguage';
import { Merch } from './Merch';
import { FlexDiv, Page } from '@Main/elements';
import { PageNavigation, Margin } from '@helpers';

import { useStaticQuery, graphql } from "gatsby"

export const Branding = ({t, i18n}) => {
    i18n.loadNamespaces('branding');

    const pages = [
        {
            title: 'Styling elements',
            component: StylingElement,
        },
        {
            title: 'Marketing media style',
            component: MediaStyle,
        },
        {
            title: 'Acceptable image language',
            component: ImageLanguage,
        },
        {
            title: 'Documentation and merchandise branding',
            component: Merch,
        },
    ];

    const data = useStaticQuery(graphql`
        {
            images: allFile(filter: {relativeDirectory: {eq: "branding"}, extension: {eq: "png"}}) {
                edges {
                    node {
                        childImageSharp {
                            gatsbyImageData(width: 800, placeholder: DOMINANT_COLOR, formats: NO_CHANGE, quality: 100)
                        }
                        name
                        publicURL
                        relativePath,
                        extension
                    }
                }
            },
            zips: allFile(filter: {relativeDirectory: {eq: "branding"}, extension: {eq: "zip"}}) {
                edges {
                    node {
                        name
                        publicURL
                        relativePath,
                        extension
                    }
                }
            }
        }
    `)

    const getPng = (fileName) => {
        const file = data.images.edges.filter(edge => edge.node.name === fileName)[0];

        return file.node;
    }

    const getZip = (fileName) => {
        const file = data.zips.edges.filter(edge => edge.node.name === fileName)[0];

        return file.node.publicURL;
    }

    return (
        <Page>
            <PageNavigation t={t} onThisPage={pages.map(page => t(`branding>${page.title}`))}/>
            <FlexDiv direction="column">
                { 
                    pages.map((page, index) => 
                        <Margin id={`block-${index + 1}`} key={page.title} marginTop={index && '50px'}>
                            {
                                React.createElement(page.component, {
                                        key: index,
                                        getPng: getPng,
                                        getZip: getZip,
                                        t: (text) => t(`branding>${text}`)
                                })
                            }
                        </Margin>
                    )
                }
            </FlexDiv>
        </Page>
    );
};

export const BrandingContainer = withTrans(Branding);